import React from 'react'
import { Accordion } from 'react-bootstrap'
import styles from './styles/CustomAccordion.module.css'

interface CustomAccordionProps {
  title: string
  children: React.ReactNode
  className?: string
  defaultExpanded?: boolean
}

export const CustomAccordion: React.FC<CustomAccordionProps> = ({
  title,
  children,
  className,
  defaultExpanded = false,
}) => {
  const eventKey = '0'

  return (
    <Accordion
      defaultActiveKey={defaultExpanded ? eventKey : undefined}
      className={`accordion-borderless ${styles.accordion} ${className ?? ''}`}
    >
      <Accordion.Item eventKey={eventKey}>
        <Accordion.Header>
          <div className={styles.customHeaderContent}>
            <span className={styles.title}>{title}</span>
          </div>
        </Accordion.Header>
        <Accordion.Body>{children}</Accordion.Body>
      </Accordion.Item>
    </Accordion>
  )
}
